import { UserContactForRecipientModal } from './iContact';
import { GroupContactsForRecipient } from './iContact/contact/group-contacts';
import { LowInformationContact } from './iContact/contact/low-information-contact';
import { ServiceChildParent } from './iCourrier/service';

export class RecipientModalOnCloseDatas {
  contactArray: LowInformationContact[];
  usersArray: UserContactForRecipientModal[];
  groupsArray: GroupContactsForRecipient[];
  serviceArray: ServiceChildParent[];
  freeRecipientArray: { id: string; name: string }[];
}
